"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const ListHeader_1 = __importDefault(require("./ListHeader"));
const ListItem_1 = __importDefault(require("./ListItem"));
const helpers_1 = require("../../../common/helpers/helpers");
const DailyViewHelpers_1 = require("./DailyViewHelpers");
const ListContainer = styled_components_1.default.ul `
  list-style: none;
  background-color: white;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const ListHeaderWrapper = styled_components_1.default.div `
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  height: ${({ hasItems }) => (hasItems ? '42px' : '0')};
  display: flex;
  align-items: center;
  transition: transform ${({ scrollDirection }) => (scrollDirection === 'down' ? '2.5s' : '0.5s')} linear;
`;
const List = ({ items, brandInfo, timezone, displayedItemId, onScrollToTop, currentLocale }) => {
    const listContainerRef = (0, react_1.useRef)(null);
    const [scrollDirection, setScrollDirection] = (0, react_1.useState)('down');
    const todayHeaderRef = (0, react_1.useRef)(null);
    const tomorrowHeaderRef = (0, react_1.useRef)(null);
    const dayAfterTomorrowHeaderRef = (0, react_1.useRef)(null);
    const handleScroll = (0, react_1.useCallback)(() => {
        const listContainer = listContainerRef.current;
        if (!listContainer && items.length >= 4)
            return;
        const todayHeader = todayHeaderRef.current;
        const tomorrowHeader = tomorrowHeaderRef.current;
        const dayAfterTomorrowHeader = dayAfterTomorrowHeaderRef.current;
        const headers = [
            { header: todayHeader, ref: todayHeaderRef },
            { header: tomorrowHeader, ref: tomorrowHeaderRef },
            { header: dayAfterTomorrowHeader, ref: dayAfterTomorrowHeaderRef },
        ];
        const containerRect = listContainer.getBoundingClientRect();
        const headerHeight = 42;
        headers.forEach(({ header }, index) => {
            var _a;
            if (header) {
                const nextHeader = (_a = headers[index + 1]) === null || _a === void 0 ? void 0 : _a.header;
                if (nextHeader) {
                    const nextHeaderRect = nextHeader.getBoundingClientRect();
                    if (nextHeaderRect.top <= containerRect.top + headerHeight) {
                        header.style.transform = `translateY(-100%)`;
                    }
                    else {
                        header.style.transform = `translateY(0)`;
                    }
                }
            }
        });
        if (listContainer.scrollTop === 0 && onScrollToTop) {
            onScrollToTop();
        }
    }, [onScrollToTop]);
    (0, react_1.useEffect)(() => {
        const listContainer = listContainerRef.current;
        if (!listContainer)
            return;
        listContainer.addEventListener('scroll', handleScroll);
        return () => listContainer.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);
    (0, react_1.useEffect)(() => {
        const listContainer = listContainerRef.current;
        if (listContainer) {
            let scrollInterval;
            let pauseTimeout;
            const scrollDelay = 50; // Adjust the scroll delay in ms
            const scrollPause = 30000; // 30 seconds pause before scrolling starts
            const isChrome = helpers_1.Helpers.isChromeBrowser();
            const isSafari = helpers_1.Helpers.isSafariBrowser();
            // Scroll speeds for different browsers
            // These values control the scrolling behavior:
            // - 'base' is the minimum number of pixels to scroll
            // - 'percentage' is the percentage of the container's height to scroll
            // The actual scroll amount is the larger of:
            //    1. The 'base' value in pixels
            //    2. The 'percentage' of the container's height
            //
            // For example, for Chrome's downward scrolling:
            // - It will scroll at least 2 pixels
            // - Or 0.3% of the container's height, whichever is larger
            //
            // The 'up' values are generally larger to create a faster upward scroll
            //
            // These values are fine-tuned for each browser to account for
            // differences in how they handle smooth scrolling
            const scrollSpeeds = {
                chrome: {
                    down: { base: 0.9, percentage: 0.13 },
                    up: { base: 40, percentage: 8 },
                },
                safari: {
                    down: { base: 0.6, percentage: 0.1 },
                    up: { base: 80, percentage: 20 },
                },
                firefox: {
                    down: { base: 1.3, percentage: 0.3 },
                    up: { base: 80, percentage: 20 },
                },
            };
            const getScrollSpeed = (direction) => {
                if (isChrome)
                    return scrollSpeeds.chrome[direction];
                if (isSafari)
                    return scrollSpeeds.safari[direction];
                return scrollSpeeds.firefox[direction]; // Default to Firefox speeds
            };
            const calculateScrollAmount = (direction) => {
                const { base, percentage } = getScrollSpeed(direction);
                const containerHeight = listContainer.clientHeight;
                return Math.max(base, containerHeight * (percentage / 100));
            };
            const startScrolling = () => {
                scrollInterval = setInterval(() => {
                    const scrollDownAmount = calculateScrollAmount('down');
                    const scrollUpAmount = calculateScrollAmount('up');
                    if (scrollDirection === 'down') {
                        if (listContainer.scrollTop + listContainer.clientHeight >= listContainer.scrollHeight - scrollDownAmount) {
                            clearInterval(scrollInterval);
                            setScrollDirection('up');
                            pauseTimeout = setTimeout(() => {
                                startScrolling();
                            }, scrollPause);
                        }
                        else {
                            if (isChrome) {
                                listContainer.scrollBy({ top: scrollDownAmount });
                            }
                            else {
                                listContainer.scrollBy({ top: scrollDownAmount, behavior: 'smooth' });
                            }
                        }
                    }
                    else {
                        if (listContainer.scrollTop <= 0) {
                            clearInterval(scrollInterval);
                            setScrollDirection('down');
                            pauseTimeout = setTimeout(() => {
                                startScrolling();
                            }, scrollPause);
                        }
                        else {
                            if (isChrome) {
                                listContainer.scrollBy({ top: -scrollUpAmount });
                            }
                            else {
                                listContainer.scrollBy({ top: -scrollUpAmount, behavior: 'smooth' });
                            }
                        }
                    }
                }, scrollDelay);
            };
            pauseTimeout = setTimeout(() => {
                startScrolling();
            }, scrollPause);
            return () => {
                clearInterval(scrollInterval);
                clearTimeout(pauseTimeout);
            };
        }
    }, [items, scrollDirection]);
    const { dayAfterTomorrow } = (0, DailyViewHelpers_1.getDates)();
    const filteredItems = items.filter(item => item.id !== displayedItemId);
    const todayItems = filteredItems.filter(item => (0, DailyViewHelpers_1.isToday)(item.start) && !(0, DailyViewHelpers_1.hasStarted)(item.start));
    const tomorrowItems = filteredItems.filter(item => (0, DailyViewHelpers_1.isTomorrow)(item.start));
    const dayAfterTomorrowItems = filteredItems.filter(item => (0, DailyViewHelpers_1.isDayAfterTomorrow)(item.start));
    const renderListItem = (items, item, index) => {
        return (react_1.default.createElement("li", { key: item.id },
            react_1.default.createElement(ListItem_1.default, { item: item, isLast: index === items.length - 1, brandInfo: brandInfo, timezone: timezone })));
    };
    return (react_1.default.createElement(ListContainer, { ref: listContainerRef },
        react_1.default.createElement(ListHeaderWrapper, { ref: todayHeaderRef, scrollDirection: scrollDirection, hasItems: todayItems.length > 0 }, todayItems.length > 0 && react_1.default.createElement(ListHeader_1.default, { text: i18n_js_1.default.t('ds_daily_view_also_today', { currentLocale }) })),
        todayItems.map((item, index) => renderListItem(todayItems, item, index)),
        tomorrowItems.length > 0 && (react_1.default.createElement(ListHeaderWrapper, { ref: tomorrowHeaderRef, scrollDirection: scrollDirection, hasItems: tomorrowItems.length > 0 },
            react_1.default.createElement(ListHeader_1.default, { text: i18n_js_1.default.t('ds_daily_view_coming_tomrrow', { currentLocale }) }))),
        tomorrowItems.map((item, index) => renderListItem(tomorrowItems, item, index)),
        dayAfterTomorrowItems.length > 0 && (react_1.default.createElement(ListHeaderWrapper, { ref: dayAfterTomorrowHeaderRef, scrollDirection: scrollDirection, hasItems: dayAfterTomorrowItems.length > 0 },
            react_1.default.createElement(ListHeader_1.default, { text: `${i18n_js_1.default.t('ds_daily_view_coming_on_day', { currentLocale })} ${helpers_1.Helpers.getWeekdayDateAndMonth(dayAfterTomorrow.toString(), timezone)}` }))),
        dayAfterTomorrowItems.map((item, index) => renderListItem(dayAfterTomorrow, item, index))));
};
exports.default = List;
